{
 "id": "sanctuary-mountain",
 "light": 0.6,
 "_note": "M10 Kanemori Sanctuary strip (x256-335), the countryside valley the mountain road winds through (walkable forest floor, garden, onsen, rest stop). Only the map edges and a few small structures are solid: the tea house, onsen hut and vending machines are countryBase footprints whose upright art is placed by hd-sanctuary-country.ts; f* rectangles (face 0) are the solid map edge. Painters: client/src/hd-sanctuary.ts (kinds, roofs) and hd-sanctuary-place.ts (ground, edges, props, lights).",
 "rect": {
  "x": 256,
  "y": 96,
  "w": 80,
  "h": 48
 },
 "lamps": [],
 "buildings": [
  { "id": "tea-house", "x": 288, "y": 111, "w": 4, "h": 3, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "onsen-hut", "x": 305, "y": 109, "w": 5, "h": 2, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "vending", "x": 285, "y": 140, "w": 2, "h": 1, "face": 0, "kind": "sanctFill", "roof": "countryBase" },
  { "id": "f36", "x": 334, "y": 96, "w": 2, "h": 48, "face": 0, "kind": "sanctFill", "roof": "sanctCedar" },
  { "id": "f37", "x": 258, "y": 142, "w": 76, "h": 2, "face": 0, "kind": "sanctFill", "roof": "sanctCedar" },
  { "id": "wall-m", "x": 256, "y": 96, "w": 2, "h": 48, "face": 0, "kind": "sanctFill", "roof": "sanctWall" }
 ]
}
